﻿import { autorun } from 'mobx';
import { ChartHybrid, isMsgChart } from "../../models/ChartModels";
import { ChartStates } from '../../models/ChartStates';
import DepthLayerBase, { Options } from './DepthLayerBase';

class DepthLayer extends DepthLayerBase {
    constructor(
        states: ChartStates,
        options: Options,
        baseUrl?: string) {

        super(states.chart, options);

        this.mobxDisposer.add([
            autorun(() => {
                if (states.token.token && baseUrl) {
                    const url = baseUrl
                        .replace("{type}", "bathy_client_height")
                        .replace("{token}", states.token.token);
                    this.source.setUrl(url);
                }
                else {
                    this.source.setUrl("");
                }
                this.source.changed();
            }),

            autorun(() => {
                const state = states.chart;
                this.setVisible(isMsgChart(state) && state.hybrid === ChartHybrid.Bathymetry);
            })
        ])
    }
}

export default DepthLayer;